import { Flex, FlexProps, Heading } from '@chakra-ui/react';
import React from 'react';

type PortfolioEventsPageMainHeaderProps = FlexProps & React.RefAttributes<HTMLDivElement>

export const PortfolioEventsPageMainHeader: React.FC<PortfolioEventsPageMainHeaderProps> = ({
    ...props
}) => (
    <Flex
        flexDirection="row"
        {...props}
    >
        <Heading
            flex={1}
            textDecoration="underline"
        >
            НАШЕ ПОРТФОЛИО
        </Heading>
    </Flex>
);
